import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter, Link } from 'react-router-dom';
import { Breadcrumbs, ListPagination } from '../../../../../../components/UI/ComponentsUI';
import { translate } from '../../../../../../utils/util';
import * as deliveryAction from '../../../../../../actions/deliveryAction';
import { ENUMS } from '../../../../../../utils/constants';
import ConfirmModalDelivery from './ConfirmModalDelivery';
import DeliveryService from '../../../../../../services/DeliveryService';

const DeliveryOrders = (props) => {
    const messageModal = useRef();
    const [currentPage, setCurrentPage] = useState(0);
    const [ordersGroup, setOrders] = useState([]);
    const routeId = props.location?.state?.routeId;

    useEffect(() => {
        if (routeId) {
            const items = props.groupDelivery?.groupOrdesDelivery.filter((f) => f.routeId === routeId)
            setOrders(items);
        } else {
            setOrders(props.groupDelivery?.groupOrdesDelivery);
        }
        //eslint-disable-next-line
    }, [props.groupDelivery?.groupOrdesDelivery]);

    useEffect(() => {
        if (!routeId && ordersGroup.length > 0 && isValidConfirm()) {
            return openModal();
        }

        if (props.nextPdu && ordersGroup.length > 0) {
            const orderSet = orderByList()[0];
            props.setOrders(orderSet.orders);
            return props.history.push({
                pathname: `../delivery/orders/mission`
            });
        }

        return () => {
            props.setNextListPdu(false);
        };
        //eslint-disable-next-line
    }, [ordersGroup]);

    const orderByList = () => {
        if (ordersGroup?.length > 0) {
            ordersGroup.forEach(element => {
                const arrayItem = [];
                element.orders.forEach(elementItem => {
                    const item = elementItem.items[0];
                    arrayItem.push(item)
                });
                const check = itensCheck(arrayItem);

                if (check) {
                    element.sequence = 100 + element.sequence;
                }
            });

            return ordersGroup.sort((a, b) => (a.sequence > b.sequence) ? 1 : ((b.sequence > a.sequence) ? -1 : 0))
        }
        return ordersGroup;
    }

    const subtitlesPickingFilterByUser = () => {
        return [{ icon: "business_center", label: translate('delivery:fields.pdus') }];
    }

    const totalItems = (location) => {
        const group = props.groupDelivery?.groupOrdesDelivery;
        if (!group) {
            return '';
        }
        const total = group.find(i => i.location === location).orders.filter(f => f.items).length
        return total
    };

    const isValidConfirm = () => {
        const orders = [];
        const array = [];
        ordersGroup.map((g) => orders.push(g.orders));

        if (!orders) {
            return false;
        }
        orders.forEach(element => {
            const item = element[0].items[0];
            array.push(item)
        });

        return itensCheck(array);
    }

    const isValidItems = (index) => {
        const orders = ordersGroup[index].orders;
        const array = [];
        if (!orders) {
            return false;
        }
        orders.forEach(element => {
            const item = element.items[0];
            array.push(item)
        });

        return itensCheck(array);
    }

    const itensCheck = (array) => {
        const itens = array.filter((f) => f.status === ENUMS.eOrderItemStatus.Finished.value || f.status === ENUMS.eOrderItemStatus.WaitingFinish.value);
        if (itens.length > 0 && itens.length === array.length) {
            return true;
        }
        return false;
    }

    const openModal = () => {
        const modal = messageModal.current;
        if (!modal.isOpen) {
            modal.show();
            modal.focus();
        }
    }

    const onConfirmModal = (qrCode) => {
        props.confirmation(qrCode, () => {
            props.history.replace({
                pathname: `../delivery/startDelivery`
            });
        });
    }

    return (
        <div>
            <Breadcrumbs id="pickingFilterByUser" title={{ icon: "mdi mdi-camera-timer", label: translate('title', 'delivery') }} subtitles={subtitlesPickingFilterByUser()} />
            <div className="container-fluid" style={{ marginTop: '40px' }}>
                <div id="listOrdersDelivery">
                    <ListPagination
                        page={0}
                        current={{ currentPage, setCurrentPage }}
                        data={
                            orderByList().map((item, index) => (
                                <>
                                    <span
                                        className="title sixth-text-color right"
                                        style={{ position: 'absolute', marginTop: '0px', right: '10px', zIndex: '999' }}
                                    ><i className={`mdi mdi-48px mdi-checkbox-multiple-marked-circle-outline ${isValidItems(index) ? 'green' : 'gray'}-text`} />
                                    </span>
                                    <Link
                                        className="row"
                                        to={{ pathname: '../delivery/orders/mission' }}
                                        onClick={() => {
                                            props.setOrders(item.orders);
                                        }}
                                        style={{ display: 'block', marginBottom: '0px' }}
                                    >
                                        <span className="title sixth-text-color" style={{ marginLeft: '10px' }} >
                                            {`${item.location || ''}`}
                                        </span>
                                        <span className="truncate second-text-color" style={{ marginLeft: '10px', paddingBlockEnd: '10px' }}>
                                            {translate('delivery:general.totalItens')}: {totalItems(item.location)}
                                        </span>
                                    </Link>
                                </>
                            ))
                        }
                    />
                </div>
                {
                    !routeId && isValidConfirm() && (<div className="row" style={{ marginBottom: '0px' }}>
                        <button
                            type="button"
                            className="col s12 m3 btn btn-principal waves-effect waves-light"
                            style={{ width: '100%' }}
                            onClick={() => openModal()}
                        >
                            {translate('delivery:general.finish')}
                        </button>
                    </div>)
                }
            </div>
            {
                !routeId && (
                    <ConfirmModalDelivery
                        ref={messageModal}
                        id="confirmOrderStart"
                        data={{ title: translate('validations:attention'), message: `${translate('delivery:message.confirmDelivery')}` }}
                        onConfirm={onConfirmModal}
                    />
                )

            }
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        groupDelivery: state.deliveryReducer.deliveryGroup,
        nextPdu: state.deliveryReducer.nextPdu,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOrders: (orders) => {
            dispatch(deliveryAction.setOrders(orders));
        },
        confirmation: (item, callback) => {
            dispatch(DeliveryService.FinishDelivery(item, callback));
        },
        setNextListPdu: (nextPdu) => {
            dispatch(deliveryAction.setNextPdu(nextPdu));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DeliveryOrders)));